import { render, staticRenderFns } from "./GeneralUse.vue?vue&type=template&id=75c4d4cc&"
import script from "./GeneralUse.vue?vue&type=script&lang=js&"
export * from "./GeneralUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports